// src/app/services/adpGage.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IEnclosure, IEnclosureParams, UpdatePayload } from '../models';

export const enclosureApi = createApi({
  reducerPath: 'enclosureApi',
  baseQuery,
  endpoints: (builder) => ({
    getEnclosureParams: builder.query<{ enclosure: IEnclosureParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/enclosures/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getEnclosure: builder.query<IEnclosure, number>({
      query: (id) => `/api/v1.0/ahu/enclosures/${id}`,
      transformResponse: (data: IEnclosure) => {
        data.params = data.enclosure_params ? JSON.parse(data.enclosure_params) : {};
        return data;
      },
    }),
    getAllEnclosuresCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/enclosures/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getEnclosuresCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/enclosures/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateEnclosure: builder.mutation<IEnclosure, UpdatePayload<IEnclosure>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/enclosures/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: IEnclosure) => {
        data.params = data.enclosure_params ? JSON.parse(data.enclosure_params) : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetEnclosureQuery,
  useGetEnclosureParamsQuery,
  useGetAllEnclosuresCountQuery,
  useLazyGetEnclosuresCountQuery,
  useGetEnclosureQuery,
  useUpdateEnclosureMutation,
} = enclosureApi;
